import { OperatorTypeEnum } from 'types/tableTypes'
import { encodeUri } from 'utils'

export function ObGridFilterByTextQuery(filterModel: any, key: string, query: any) {
  switch (filterModel[key].type) {
    case OperatorTypeEnum.notContains:
      query.push(obGridFilterQueryGenerator(key, 'notlike', `%${filterModel[key].filter}%`))
      break
    case OperatorTypeEnum.equals:
      query.push(obGridFilterQueryGenerator(key, 'like', filterModel[key].filter))
      break
    case OperatorTypeEnum.notEqual:
      query.push(obGridFilterQueryGenerator(key, 'notlike', filterModel[key].filter))
      break
    case OperatorTypeEnum.startsWith:
      query.push(obGridFilterQueryGenerator(key, 'like', `${filterModel[key].filter}%`))
      break
    case OperatorTypeEnum.endsWith:
      query.push(obGridFilterQueryGenerator(key, 'like', `%${filterModel[key].filter}`))
      break
    default:
      query.push(
        `Filter=${encodeUri({
          path: key,
          operator: 'like',
          value: '%' + filterModel[key].filter + '%',
        })}`,
      )
      break
  }
  return query
}

export function ObGridFilterByNumberQuery(filterModel: any, key: string, query: any) {
  switch (filterModel[key].type) {
    case OperatorTypeEnum.greaterThanOrEqual:
      query.push(obGridFilterQueryGenerator(key, '>=', filterModel[key].filter))
      break
    case OperatorTypeEnum.inRange:
      query.push(obGridFilterQueryGenerator(key, '>=', filterModel[key].filter))
      query.push(obGridFilterQueryGenerator(key, '<=', filterModel[key].filterTo))
      break
    case OperatorTypeEnum.lessThanOrEqual:
      query.push(obGridFilterQueryGenerator(key, '<=', filterModel[key].filter))
      break
    case OperatorTypeEnum.equals:
      query.push(obGridFilterQueryGenerator(key, '=', filterModel[key].filter))
      break
  }
  return query
}

export function ObGridFilterByDateQuery(filterModel: any, key: string, query: any) {
  const dateFrom = filterByDateFrom(filterModel, key)
  const dateTo = filterByDateTo(filterModel, key)

  const filterValueDateFrom = [
    dateFrom.getFullYear(),
    ('0' + (dateFrom.getMonth() + 1)).slice(-2),
    ('0' + dateFrom.getDate()).slice(-2),
  ].join('-')

  const filterValueDateTo = [
    dateTo.getFullYear(),
    ('0' + (dateTo.getMonth() + 1)).slice(-2),
    ('0' + dateTo.getDate()).slice(-2),
  ].join('-')

  switch (filterModel[key].type) {
    case OperatorTypeEnum.greaterThan:
      query.push(obGridFilterQueryGenerator(key, '>=', filterValueDateFrom))
      break
    case OperatorTypeEnum.inRange:
      query.push(obGridFilterQueryGenerator(key, '>=', filterValueDateFrom))
      query.push(obGridFilterQueryGenerator(key, '<=', filterValueDateTo))
      break
    case OperatorTypeEnum.lessThan:
      query.push(obGridFilterQueryGenerator(key, '<=', filterValueDateFrom))
      break
  }
  return query
}

export function obGridFilterQueryGenerator(
  path: string,
  operator: string,
  value: Array<string> | string | Array<number>,
) {

  const filterValue = Array.isArray(value)
  if (filterValue) {

    return `Filter=${encodeUri({
      path: path,
      operator: operator,
      valueList: value,
    })}`
  } else {
    return `Filter=${encodeUri({
      path: path,
      operator: operator,
      value: value!,
    })}`
  }
}

export function obGridSortQueryGenerator(path: string, sort: boolean) {
  return `Sort=${encodeUri({
    path: path,
    descending: sort,
  })}`
}

function filterByDateFrom(filterModel: any, key: string) {
  return new Date(filterModel[key].dateFrom)
}
function filterByDateTo(filterModel: any, key: string) {
  return new Date(filterModel[key].dateTo)
}

export const setFilterWidthDynamically = (values: Array<string>) => {
  const MIN_CHAR = 22
  const longestString = values?.reduce((a: string, b: string) => (a?.length >= b?.length ? a : b))
  const popup = document?.querySelector('.ag-filter-virtual-list-container') as HTMLElement
  if (popup?.style) {
    popup.style.width = `${longestString.length > MIN_CHAR ? longestString.length : MIN_CHAR}ch`
  }
}
